'use client';

import { useEffect, useState } from 'react';

import { FeedbackFormLinkProps } from './types';

import IconLink from '@/assets/icons/iconLink.svg';
import getImageUrl from '@/shared/api/getImageUrl';

export const FeedbackFormLink = ({
  onLinkClick,
  title,
  linkLabel,
}: FeedbackFormLinkProps) => {
  const [imageSrc, setImageSrc] = useState('');

  useEffect(() => {
    const fetchImageUrl = async () => {
      const result = await getImageUrl('/images/navigationCardBackground.png');
      setImageSrc(result.imageUrl);
    };

    fetchImageUrl();
  }, []);

  return (
    <div className="bg-surface-base-blur relative h-48 w-[294px] rounded-xl max-sm:w-full">
      <div className="absolute top-0 left-0 flex h-full w-full flex-col justify-between rounded-xl bg-gradient-to-br from-[rgba(68,180,60,0.15)] to-[rgba(60,69,75,0)] px-6 py-4">
        <span className="text-lg leading-6 tracking-[-0.018rem]">{title}</span>
        <a
          className="hover:text-status-accent flex cursor-pointer align-middle"
          onClick={onLinkClick}
        >
          {linkLabel}
          <IconLink />
        </a>
        {imageSrc && (
          <img
            className="pointer-events-none absolute bottom-0 left-[-2px]"
            src={imageSrc}
            alt="navigationCardBackground"
          />
        )}
      </div>
    </div>
  );
};
